<div
  class="flex h-full flex-col"
  [ngClass]="{
    'gap-0': space === 'sm',
    'gap-10': space === 'md'
  }">
  <div class="flex justify-between gap-6">
    <div>
      <button
        *ngIf="currentPage?.navBack"
        app-icon-button
        type="button"
        name="arrow-narrow-left"
        class="mt-3"
        (click)="back()"></button>
    </div>
    <ng-container
      *ngIf="currentPage?.headerAction"
      [ngTemplateOutlet]="currentPage!.headerAction!"></ng-container>
  </div>

  <div class="relative flex-1 overflow-hidden">
    <div
      *ngFor="let page of activePages; let index = index"
      class="absolute top-0 flex h-full w-full flex-col gap-6 overflow-y-auto overflow-x-hidden transition-all"
      [style.left]="(index - activePageIndex) * 100 + '%'">
      <ng-container *ngIf="page" [ngTemplateOutlet]="page.content"></ng-container>
    </div>
  </div>
</div>
